module.exports = __webpack_public_path__ + "img/image-gallery-icon.da23b67d.svg";